// extracted by mini-css-extract-plugin
module.exports = {"App":"App__-lcoal-__1o-Fp"};